var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-section"},[_c('div',{staticClass:"g-header"},[_c('h3',[_vm._v("我们的海内外的学生，可以拿到这些公司的Offer")]),_c('p',[_vm._v("坚实的口碑，真实的offer案例，速成刷题踏入世界主流IT公司")])]),_c('div',{staticClass:"container"},[_c('div',{staticClass:"hz-cells"},[_c('img',{attrs:{"alt":"","src":require("@/assets/images/scb/logos.png")}})])])])
}]

export { render, staticRenderFns }